import { render, staticRenderFns } from "./UploadProfile.vue?vue&type=template&id=747104b6&scoped=true"
import script from "./UploadProfile.vue?vue&type=script&lang=js"
export * from "./UploadProfile.vue?vue&type=script&lang=js"
import style0 from "./UploadProfile.vue?vue&type=style&index=0&id=747104b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747104b6",
  null
  
)

export default component.exports